import axiosInstance from '../auth/axiosInstance';

const throwIfFailed = (result, fallback) => {
  if (result?.code && result.code >= 400) {
    throw new Error(result.message || fallback);
  }
  return result?.data ?? result;
};

export const getTraxccelFrameworks = async (
  pageNumber = 1,
  pageSize = 10,
  sort = 'name-asc',
  search = ''
) => {
  const { data: result } = await axiosInstance.get('/TraxccelFramework/GetTraxccelFrameworks', {
    params: { pageNumber, pageSize, sort, search },
  });

  if (
    result?.data &&
    Array.isArray(result.data.items) &&
    typeof result.data.totalCount === 'number'
  ) {
    const { items, totalCount, pageNumber: returnedPage, pageSize: returnedSize } = result.data;
    return {
      items,
      totalCount,
      pageNumber: returnedPage,
      pageSize: returnedSize,
    };
  }

  return { items: [], totalCount: 0, pageNumber, pageSize };
};

function normalizeTraxccelFrameworkDetail(raw: Record<string, unknown> | null | undefined) {
  if (!raw || typeof raw !== 'object') {
    return raw;
  }

  const tree = raw.tree ?? raw.Tree;
  return {
    ...raw,
    tree: Array.isArray(tree) ? tree : [],
  };
}

export const getTraxccelFramework = async (id) => {
  const { data: result } = await axiosInstance.get(`/TraxccelFramework/GetTraxccelFramework/${id}`, {
    timeout: 120_000,
  });
  const detail = throwIfFailed(result, 'Failed to load Traxccel Framework');
  return normalizeTraxccelFrameworkDetail(detail as Record<string, unknown>);
};

export const addOrUpdateTraxccelFramework = async (payload) => {
  const { data: result } = await axiosInstance.post(
    '/TraxccelFramework/AddOrUpdateTraxccelFramework',
    payload
  );
  return throwIfFailed(result, 'Failed to save Traxccel Framework');
};

export const deleteTraxccelFramework = async (id) => {
  const { data: result } = await axiosInstance.post(
    `/TraxccelFramework/DeleteTraxccelFramework/${id}`
  );
  return throwIfFailed(result, 'Failed to delete Traxccel Framework');
};
